import viewport from 'responsive-toolkit/src/bootstrap-toolkit';

export function menu() {

  const visibilityDivs = {
    'xs': $('<div class="d-xs-block d-sm-none d-md-none d-lg-none d-xl-none"></div>'),
    'sm': $('<div class="d-none d-sm-block d-md-none d-lg-none d-xl-none"></div>'),
    'md': $('<div class="d-none d-md-block d-sm-none d-lg-none d-xl-none"></div>'),
    'lg': $('<div class="d-none d-lg-block d-sm-none d-md-none d-xl-none"></div>'),
    'xl': $('<div class="d-none d-xl-block d-sm-none d-md-none d-lg-none"></div>'),
  };

  const body = $('body');
  const menu = $('.header-nav');
  const menu_bg_layer = $('.header .menu-bg-layer');

  viewport.use('custom', visibilityDivs);

  $('li.dropdown').hover(
    function() {
      body.addClass('menu-open');

      if($(this).hasClass('skimeisterschaft')){
        body.addClass('menu-open-blue');
      } else {
        body.removeClass('menu-open-blue');
      }

      if(viewport.is('>=xl')) {
        var dropdownmenu = $(this).find('.dropdown-menu');
        var description = $(this).find('.menu-description');
        dropdownmenu.addClass('visible');
        description.addClass('visible');
        var result = Math.max(dropdownmenu.outerHeight(), description.outerHeight());

        if (dropdownmenu.outerHeight() > description.outerHeight()) {
          description.css('height', dropdownmenu.outerHeight())
        }

        menu_bg_layer.css('height', result)
      }

    }, function() {
      if(viewport.is('>=xl')) {
        var dropdownmenu = $(this).find('.dropdown-menu');
        var description = $(this).find('.menu-description');
        dropdownmenu.removeClass('visible');
        description.removeClass('visible');
        body.removeClass('menu-open').removeClass('menu-open-blue');
        $('#search-field').val('');
        menu_bg_layer.css('height', 0);
      }
    }
  );

  $('header .header-search').hover(
    function() {
      body.addClass('menu-open');
      if(viewport.is('>=xl')) {
        menu_bg_layer.css('height', $('.header-search-layer').outerHeight())
      }
    }, function() {
      if(viewport.is('>=xl')) {
        body.removeClass('menu-open');
        $('#search-field').val('');
        menu_bg_layer.css('height', 0);
      }
    }
  );

  $(window).resize(
    viewport.changed(function() {
      var description = $('.menu-description');
      description.removeAttr('style');

      if(viewport.is('>=xl')) {
        body.removeClass('menu-open');
        menu.removeClass('mobile-menu-open');
      }
    })
  );

  // mobile
  $('.navbar-toggler').on('click',function() {
    body.toggleClass('menu-open');
    menu.toggleClass('mobile-menu-open');
    $('.sub-nav').removeClass('submenu-opened');
    $('#search-field').val('');
  });

  $('.dropdown > a').on('click',function(e) {
    if(viewport.is('<xl')) {
      e.preventDefault();
      const submenu = $(this).next();
      submenu.addClass('submenu-opened');
      $('#search-field').val('');
    }
  });

  $('.sub-nav-back').on('click',function(e) {
    e.preventDefault();
    $('.sub-nav').removeClass('submenu-opened');
  });

  // end mobile
  $(window).scroll(function () {
    if ($(this).scrollTop() > 50) {
      body.addClass('menu-shrink');
    } else {
      body.removeClass('menu-shrink');
    }
  });

  // anchor smooth scroll
  const anchorScroll = () => {
    if(window.location.hash) {
      var hash = window.location.hash;

      if ($(hash).length) {
        body.addClass('menu-shrink');
        setTimeout(function () {
          var offsetTop = $('.navbar').outerHeight();

          $('html, body').animate({
            scrollTop: $(hash).offset().top - offsetTop,
          }, 300);
        }, 500)
      }
    }
  }

  $(window).on('load', function () {
    anchorScroll();
  });

  $('.dropdown-menu .active .nav-link').click(function (e) {
    e.preventDefault();

    var target = this.hash;
    var dropdownmenu = $('.dropdown-menu');
    var description = $('.menu-description');

    dropdownmenu.removeClass('visible');
    description.removeClass('visible');
    body.removeClass('menu-open');
    $('#search-field').val('');
    menu_bg_layer.css('height', 0);
    menu.removeClass('mobile-menu-open');
    $('.sub-nav').removeClass('submenu-opened');

    if (typeof target != undefined && target != '') {
      history.replaceState(undefined, undefined, target)

      var offsetTop = $('.navbar').outerHeight();
      if(!body.hasClass('menu-shrink')) {
        body.addClass('menu-shrink');
        setTimeout(function () {
          offsetTop = $('.navbar').outerHeight()

          $('html, body').animate({
            scrollTop: $(target).offset().top - offsetTop,
          }, 300);
        }, 300)
      } else {
        offsetTop = $('.navbar').outerHeight()

        $('html, body').animate({
          scrollTop: $(target).offset().top - offsetTop,
        }, 400);
      }
    } else {
      $('html, body').animate({
        scrollTop: 0,
      }, 400);
    }
  });
}



// WEBPACK FOOTER //
// ./scripts/components/menu.js